/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '../../assets/css/bootstrap.min.css.shim.ngstyle';
import * as import1 from '../../assets/sass/checkout.scss.shim.ngstyle';
import * as import2 from '@angular/core';
import * as import3 from '@angular/common';
import * as import4 from '../../../app/service/service-offer-summary.component';
import * as import5 from '@angular/router';
import * as import6 from '../../../app/services/checkout.service';
import * as import7 from '../../../app/services/cart.service';
import * as import8 from '../../../app/services/api.service';
const styles_ServiceOfferSummaryComponent:any[] = [
  import0.styles,
  import1.styles
]
;
export const RenderType_ServiceOfferSummaryComponent:import2.RendererType2 = import2.ɵcrt({
  encapsulation: 0,
  styles: styles_ServiceOfferSummaryComponent,
  data: {}
}
);
function View_ServiceOfferSummaryComponent_3(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['/mies.']))
  ]
  ,(null as any),(null as any));
}
function View_ServiceOfferSummaryComponent_2(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),18,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                        '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'text-danger'
      ]
      ,
      [
        'title',
        'Usuń usługę'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.removeService(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['X'])),
    (l()(),import2.ɵted((null as any),[
      '\n                        ',
      ' -\n                        ',
      '',
      '\n                    '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n                    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                        '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),3,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł'
    ]
    )),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServiceOfferSummaryComponent_3)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                    '])),
    (l()(),import2.ɵted((null as any),['\n                '])),
    (l()(),import2.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_4:boolean = !v.context.$implicit.single;
    ck(v,15,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    const currVal_1:any = v.context.$implicit.count;
    const currVal_2:any = v.context.$implicit.unit;
    ck(v,8,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = (v.context.$implicit.count * v.context.$implicit.netto).toFixed(2).replace('.',',');
    ck(v,13,0,currVal_3);
  });
}
function View_ServiceOfferSummaryComponent_1(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),13,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'checkout-summary-box__position'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'h4',[[
        'class',
        'checkout-summary-box__position-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      '\n                '
    ]
    )),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.returnToServices(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['dodaj kolejne'])),
    (l()(),import2.ɵted((null as any),['\n            '])),
    (l()(),import2.ɵted((null as any),['\n            '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServiceOfferSummaryComponent_2)),
    import2.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.services[v.context.$implicit];
    ck(v,11,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.getParentName(v.context.$implicit);
    ck(v,5,0,currVal_0);
  });
}
function View_ServiceOfferSummaryComponent_4(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__total-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__total-box-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Opłata miesięczna'])),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__total-box-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n            ',
      ' zł\n        '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.getTotalAmount(true) * 1.23).toFixed(2).replace('.',',');
    ck(v,6,0,currVal_0);
  });
}
export function View_ServiceOfferSummaryComponent_0(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),54,'div',[[
        'class',
        'checkout-summary-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'class',
        'checkout-summary-box__title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Podsumowanie zamówienia'])),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'checkout-summary-box__position'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'checkout-summary-box__position-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Wybrane usługi'])),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServiceOfferSummaryComponent_1)),
    import2.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),0,'hr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),28,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                Razem\n            '])),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n\n\n\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                VAT\n            '])),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name checkout-summary-box__brutto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                Kwota brutto do zapłaty\n            '])),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServiceOfferSummaryComponent_4)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.ServiceOfferSummaryComponent = v.component;
    const currVal_0:any = co.objectKeys(co.services);
    ck(v,18,0,currVal_0);
    const currVal_4:any = (co.getTotalAmount(true) > 0);
    ck(v,53,0,currVal_4);
  },(ck,v) => {
    var co:import4.ServiceOfferSummaryComponent = v.component;
    const currVal_1:any = co.getTotalAmount(false).toFixed(2).replace('.',',');
    ck(v,30,0,currVal_1);
    const currVal_2:any = (co.getTotalAmount(false) * 0.23).toFixed(2).replace('.',',');
    ck(v,39,0,currVal_2);
    const currVal_3:any = (co.getTotalAmount(false) * 1.23).toFixed(2).replace('.',',');
    ck(v,48,0,currVal_3);
  });
}
function View_ServiceOfferSummaryComponent_Host_0(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'service-offer-summary',([] as any[]),(null as any),(null as any),(null as any),View_ServiceOfferSummaryComponent_0,RenderType_ServiceOfferSummaryComponent)),
    import2.ɵdid(114688,(null as any),0,import4.ServiceOfferSummaryComponent,[
      import5.Router,
      import6.CheckoutService,
      import7.CartService,
      import8.ApiService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServiceOfferSummaryComponentNgFactory:import2.ComponentFactory<import4.ServiceOfferSummaryComponent> = import2.ɵccf('service-offer-summary',import4.ServiceOfferSummaryComponent,View_ServiceOfferSummaryComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/service/service-offer-summary.component.ngfactory.ts